export default "__VITE_ASSET__CahK6rID__"